import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import TopicIcon from "@material-ui/icons/Label";
import { formatNumber } from "../../utils/number";

const useStyles = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "16px",
    width: "100%",
    marginBottom: "16px",
  },

  card: {
    borderRadius: "14px",
    padding: "16px 18px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "110px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },

  heading: {
    fontSize: "13px",
    fontWeight: 600,        // 🔥 stronger
    letterSpacing: "0.3px", // 🔥 improves readability
    opacity: 0.95,          // 🔥 less faded
  },

  value: {
    fontSize: "26px",       // 🔥 bigger
    fontWeight: 800,        // 🔥 bold (main focus)
    lineHeight: 1.2,
    letterSpacing: "0.5px",
  },

  icon: {
    opacity: 0.9,
  },

  "@media (max-width: 600px)": {
    container: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "10px",
    },

    card: {
      padding: "12px",
      minHeight: "90px",
    },

    value: {
      fontSize: "20px",     // still strong on mobile
    },

    heading: {
      fontSize: "11px",
      fontWeight: 600,
    },
  },
});

function secondsToHms(ms) {
  if (!ms) return "0";

  const d = Number(ms) / 1000;
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);

  return `${h}h ${m}m`;
}

function MiniCards({ data = {} }) {
  const styles = useStyles();

  const cards = [
    {
      heading: "Time Spent",
      value: secondsToHms(data.timeSpend),
      icon: <AccessTimeIcon />,
      bg: "linear-gradient(135deg,#059669, #34d399)",
    },
    {
      heading: "Questions Practiced",
      value: `${formatNumber(data.attempted || 0)}/${formatNumber(
        data.toAttempt || 0
      )}`,
      icon: <HelpOutlineIcon />,
      bg: "linear-gradient(135deg,#7c3aed, #a855f7)",
    },
    {
      heading: "Chapters Practiced",
      value: formatNumber(data.chapters || 0),
      icon: <MenuBookIcon />,
      bg: "linear-gradient(135deg,#e11d48, #fb7185)",
    },
    {
      heading: "Topics Practiced",
      value: formatNumber(data.topics || 0),
      icon: <TopicIcon />,
      bg: "linear-gradient(135deg,#0284c7, #38bdf8)",
    },
  ];

  return (
    <div className={styles.container}>
      {cards.map((item, index) => (
        <div
          key={index}
          className={styles.card}
          style={{ background: item.bg }}
        >
          <div className={styles.header}>
  <span className={styles.heading}>{item.heading}</span>
  <span className={styles.icon}>{item.icon}</span>
</div>

<div style={{ opacity: 0.2, height: 1, background: "#fff", margin: "4px 0 8px" }} />

<div className={styles.value}>{item.value}</div>
        </div>
      ))}
    </div>
  );
}

export default MiniCards;